import React, { useEffect, useState } from 'react';

export default function KeyValueEditor({
  keyPair,
  setKeyPair,
  onKeyPairRemove,
}) {
  const [keyValue, setKeyValue] = useState(keyPair);
  const [debouncedKeyValue, setDebouncedKeyValue] = useState(keyValue);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedKeyValue(keyValue);
    }, 1000);
    return () => {
      clearTimeout(timerId);
    };
  }, [keyValue]);

  useEffect(() => {
    setKeyPair(debouncedKeyValue);
    // eslint-disable-next-line
  }, [debouncedKeyValue]);

  const handleOnChange = (e) => {
    setKeyValue((prevState) => ({
      ...prevState,
      id: keyValue.id,
      [e.target.name]: e.target.value,
    }));
  };
  return (
    <>
    <div className='flex mb-2'>
      <input
        className="px-3 py-2 text-sm w-full border border-gray-300 rounded-lg hover:border-[#fdb814] focus:outline-none focus:ring-2 focus:ring-[#fdb814]/20 focus:border-[#fdb814] transition-all duration-200 bg-gray-50 hover:bg-white"
        placeholder='Key'
        name='keyItem'
        onChange={(e) => handleOnChange(e)}
      />
      <input
        className="ml-2 px-3 py-2 text-sm w-full border border-gray-300 rounded-lg hover:border-[#fdb814] focus:outline-none focus:ring-2 focus:ring-[#fdb814]/20 focus:border-[#fdb814] transition-all duration-200 bg-gray-50 hover:bg-white"
        placeholder='Value'
        name='valueItem'
        onChange={(e) => handleOnChange(e)}
      />
      <button 
        className="ml-2 px-3 py-1.5 text-xs rounded-lg font-medium text-red-500 border-2 border-red-300 hover:bg-gradient-to-r hover:from-red-500 hover:to-red-600 hover:text-white hover:border-red-500 transition-all duration-300 shadow-md hover:shadow-lg transform hover:scale-105 active:scale-95 focus:outline-none focus:ring-4 focus:ring-red-500/30"
        onClick={() => onKeyPairRemove(keyPair)}>Remove</button>
        </div>
    </>
  );
}
